import { BaseballLineupPosition, constants, Dexterity, TopBottom } from '@trackman/baseball-shared-components';
import { ApiLineupDraggablePlayer } from 'interfaces/team/ApiLineupDraggablePlayer';
import { IApiPlayLineup, ICustomMetadata } from '../../interfaces/tagging/ApiModels/IApiStadiumPlayModel';

export const emptyGameState = {
  homeTeamScore: 0,
  awayTeamScore: 0,
  inning: 1,
  topBottom: TopBottom.Top,
  balls: 0,
  strikes: 0,
  outs: 0,
};

export const emptyLineupPlayer = {
  id: constants.emptyGuid,
  battingHandedness: Dexterity.Undefined,
  pitchingHandedness: Dexterity.Undefined,
  nameRef: '',
  position: BaseballLineupPosition.Undefined,
  isPlaceholder: true,
  foreignIds: [],
  isEnabled: true,
  name: constants.emptyGuid,
  height: null,
  strikeZoneBottom: null,
  strikeZoneTop: null,
  jerseyNumber: '',
  birthDate: null,
  ids: [],
} as ApiLineupDraggablePlayer;

export const emptyCustomMetadata = {
  isNoteResolved: false,
  isValidated: false,
  taggingFlowState: '',
} as ICustomMetadata;

export const emptyApiPlayLineup = {
  homeTeam: [],
  awayTeam: [],
} as IApiPlayLineup;
